import { render, staticRenderFns } from "./BusinessContractor.vue?vue&type=template&id=46ec0b78&scoped=true&"
import script from "./BusinessContractor.vue?vue&type=script&lang=ts&"
export * from "./BusinessContractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec0b78",
  null
  
)

export default component.exports